import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gradient-to-r from-gray-900 to-stone-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-gray-700">
          {/* About */}
          <div className="pb-8 md:pb-0 md:pr-8">
            <h3 className="text-lg font-semibold mb-4">{t('footer.about')}</h3>
            <p className="text-gray-300 text-sm">
              {t('footer.aboutDesc')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="pt-8 md:pt-0 md:px-8 pb-8 md:pb-0">
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li><Link to="/hotels" className="text-gray-300 hover:text-white cursor-pointer">{t('nav.hotels')}</Link></li>
              <li><Link to="/flights" className="text-gray-300 hover:text-white cursor-pointer">{t('nav.flights')}</Link></li>
              <li><Link to="/cars" className="text-gray-300 hover:text-white cursor-pointer">{t('nav.taxi')}</Link></li>
              <li><Link to="/packages" className="text-gray-300 hover:text-white cursor-pointer">{t('nav.packages')}</Link></li>
              <li><Link to="/activities" className="text-gray-300 hover:text-white cursor-pointer">{t('nav.thingsToDo')}</Link></li>
              <li><Link to="/hajj-umrah" className="text-gray-300 hover:text-white cursor-pointer">{t('nav.hajjUmrah')}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="pt-8 md:pt-0 md:pl-8">
            <h3 className="text-lg font-semibold mb-4">{t('footer.contact')}</h3>
            <div className="text-gray-300 text-sm space-y-2">
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a 
                  href="https://wa.me/2348067677144" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white cursor-pointer transition-colors"
                >
                  +234 806 767 7144
                </a>
              </p>
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <a 
                  href="mailto:info@riglandtravels.com"
                  className="hover:text-white cursor-pointer transition-colors"
                >
                  info@riglandtravels.com
                </a>
              </p>
              <p className="flex items-start mt-2">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                <span>
                  Office No 12, Top Floor<br />
                  NNDC Mall Building No 6<br />
                  Muhammadu Buhari Way<br />
                  Kaduna, Nigeria
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-4 mb-4 md:mb-0">
              <p className="text-gray-400 text-sm">
                © 2026 Rigland Travels Ltd. {t('footer.rights')}
              </p>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="flex space-x-3">
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-twitter-fill text-xl"></i>
                </a>
                <a 
                  href="https://instagram.com/riglandtravels" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white cursor-pointer"
                >
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
